"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlatformMeta = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const DASHBOARD_PATH = '/dashboard/:dashboardId';
const usePlatformMeta = () => {
    var _a;
    const SharedHostGateway = window.sharedHostGateway;
    const dashboardSelectors = SharedHostGateway.getSelectors('dashboards');
    const widgetSelectors = SharedHostGateway.getSelectors('widgets');
    const { useDashboardByIdSelector, useCurrentGraphViewSelector } = dashboardSelectors;
    const { useStoreWidgetsSelector, usePlatformWidgetsMetaByIdSelector } = widgetSelectors;
    const storeWidgetsById = useStoreWidgetsSelector();
    const platformWidgetsById = usePlatformWidgetsMetaByIdSelector();
    // legacy approach
    const match = (0, react_router_dom_1.useRouteMatch)(DASHBOARD_PATH);
    const { dashboardId: urlDashboardId } = (_a = match === null || match === void 0 ? void 0 : match.params) !== null && _a !== void 0 ? _a : {};
    // navgraph approach
    const currentGraphView = useCurrentGraphViewSelector();
    const dashboardId = (0, react_1.useMemo)(() => { var _a; return (((_a = window.CUSTOM_ENV) === null || _a === void 0 ? void 0 : _a.navGraph) ? currentGraphView === null || currentGraphView === void 0 ? void 0 : currentGraphView.dashboardId : urlDashboardId); }, [currentGraphView, urlDashboardId]);
    const currentDashboard = useDashboardByIdSelector(dashboardId !== null && dashboardId !== void 0 ? dashboardId : '');
    return (0, react_1.useMemo)(() => ({
        storeWidgetsById,
        platformWidgetsById,
        currentDashboardId: dashboardId,
        currentDashboard
    }), [storeWidgetsById, platformWidgetsById, dashboardId, currentDashboard]);
};
exports.usePlatformMeta = usePlatformMeta;
